module.exports = __webpack_public_path__ + "img/hr-green-pita-mini-12.f9db4c58.png";